export default "__VITE_ASSET__CzbzPyYh__"